module.exports = __webpack_public_path__ + "static/media/Execution.b25a505a.svg";